import { Box } from '../../Box';
import { XMarkIcon } from '../../Icons';
import { resolveInputFontSize } from '../../TextInput/TextInputStyles';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveSize = size => {
  const map = {
    small: {
      width: '24px',
      minWidth: '24px',
      maxWidth: '24px',
      height: '24px',
      minHeight: '24px',
      maxHeight: '24px'
    },
    sm: {
      width: '24px',
      minWidth: '24px',
      maxWidth: '24px',
      height: '24px',
      minHeight: '24px',
      maxHeight: '24px'
    },
    medium: {
      width: '24px',
      minWidth: '24px',
      maxWidth: '24px',
      height: '24px',
      minHeight: '24px',
      maxHeight: '24px'
    },
    md: {
      width: '24px',
      minWidth: '24px',
      maxWidth: '24px',
      height: '24px',
      minHeight: '24px',
      maxHeight: '24px'
    },
    large: {
      width: '32px',
      minWidth: '32px',
      maxWidth: '32px',
      height: '32px',
      minHeight: '32px',
      maxHeight: '32px'
    },
    lg: {
      width: '32px',
      minWidth: '32px',
      maxWidth: '32px',
      height: '32px',
      minHeight: '32px',
      maxHeight: '32px'
    }
  };
  return map[size || 'medium'];
};
/**
 * Resolves the style object for a TextInput based on the given parameters.
 *
 * @param {InterstateTheme} theme - The theme object.
 * @param {TextInputSize} size - The size of the TextInput.
 * @param {boolean} disabled - Indicates whether the TextInput is disabled.
 * @returns {object} - The resolved style object for the TextInput.
 */
const resolveStyle = (theme, size, disabled) => ({
  ...resolveSize(size),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
  fontSize: resolveInputFontSize(theme, size),
  lineHeight: '100%',
  color: disabled ? theme.tokens.SemColorOnSurfaceInteractiveDisabled : theme.tokens.SemColorOnSurfaceSubdued,
  cursor: !disabled ? 'pointer' : 'not-allowed'
});
/**
 * Represents a clear button component in a combo box.
 *
 * @param {Object} props - The properties for the ClearButton component.
 * @param {ClearButtonProps} props - The ClearButton component properties.
 * @returns {JSX.Element} - The rendered ClearButton component.
 */
export const ClearButton = props => {
  const theme = useInterstateTheme();
  const {
    size,
    disabled,
    onClear
  } = props;
  const style = resolveStyle(theme, size, disabled);
  const handleOnClear = e => {
    e.stopPropagation();
    e.preventDefault();
    if (!disabled && onClear) {
      onClear();
    }
  };
  // Prevent the mouseDown from bubbling up to the parent containers mouseDown handler
  const handleOnMouseDown = e => {
    e.stopPropagation();
  };
  return /*#__PURE__*/_jsx(Box, {
    sx: style,
    className: 'ids-combo-box-clear-button',
    onClick: handleOnClear,
    onMouseDown: handleOnMouseDown,
    children: /*#__PURE__*/_jsx(XMarkIcon, {
      fontSize: resolveInputFontSize(theme, size)
    })
  });
};